import {
  IActivitiesByIdStage,
  ICancelMeeting,
  IConfirmSchedule,
  IEmail,
  IGetActivity,
  IGetWaitMessageActivity,
  INoCurrentActivity,
  InterviewInfo,
  IParameterRequest,
  IParameterResponse,
  IResponse,
  IResponseActivitiesByIdStage,
  IResponseMeet,
  IResponseSchedule,
  IStatus,
} from 'utils/interfaces';
import { talentoApi } from './index';

const stagesExtensionApi = talentoApi.injectEndpoints({
  endpoints: (builder) => ({
    getActivitiesByIdStage: builder.query<IResponseActivitiesByIdStage, IActivitiesByIdStage>({
      query({ idStage, idVacant, email }) {
        return {
          url: `/stages/content?idActivity=${idStage}&idVacant=${idVacant}&email=${email}`,
        };
      },
    }),

    getActivityStatus: builder.query({
      query({ idStage, idVacant, email }) {
        return {
          url: `/stages/status?idActivity=${idStage}&idVacant=${idVacant}&email=${email}`,
        };
      },
    }),

    changeStatus: builder.mutation<IResponse, IStatus>({
      query: ({ idStage, idVacant, email, status, activityName }) => ({
        url: `/stages/change-status?idActivity=${idStage}&idVacant=${idVacant}&email=${email}&status=${status}&activityName=${activityName}`,
        method: 'PUT',
      }),
    }),

    getListCalendar: builder.query({
      query({ idActivity, email }) {
        return {
          url: `/stages/list-calendar?idActivity=${idActivity}&email=${email}`,
        };
      },
    }),

    scheduleMeeting: builder.mutation({
      query: ({ idEvent, idCalendar, email, idActivity, candidateFullName }) => ({
        url: `/stages/schedule-meeting`,
        method: 'POST',
        body: {
          idEvent,
          idCalendar,
          invitedEmail: email,
          idActivity,
          candidateFullName,
        },
      }),
    }),

    reprogramMeeting: builder.query({
      query: ({ email, idActivity }) => ({
        url: `/stages/meets/reprogram-validation/${email}?idActivity=${idActivity}`,
      }),
    }),

    cancelMeeting: builder.mutation<any, ICancelMeeting>({
      query: ({ email, idActivity }) => ({
        url: `/stages/cancel-meeting?email=${email}&idActivity=${idActivity}`,
        method: 'PUT',
      }),
    }),

    confirmSchedule: builder.mutation<IResponseMeet, IConfirmSchedule>({
      query: ({ idActivity, email, startUnixDate }) => ({
        url: `/stages/schedules/${startUnixDate}?email=${email}&idActivity=${idActivity}`,
        method: 'POST',
      }),
    }),

    getSchedule: builder.query<IResponseSchedule, IEmail>({
      query({ email, idActivity }) {
        return {
          url: `/stages/schedules?email=${email}&idActivity=${idActivity}`,
        };
      },
    }),

    getEnterviewData: builder.query<InterviewInfo, IEmail>({
      query({ idActivity, email }) {
        return {
          url: `/stages/meets/${email}?idActivity=${idActivity}`,
        };
      },
    }),

    getNoCurrentActivity: builder.query<INoCurrentActivity, IGetActivity>({
      query: ({ idStage, idVacant, email }) =>
        `stages/waiting-message?idStage=${idStage}&idVacant=${idVacant}&email=${email}`,
      transformResponse: (response: { data: INoCurrentActivity }) => response.data,
    }),

    getWaitingMessageForActivity: builder.query<INoCurrentActivity, IGetWaitMessageActivity>({
      query: ({ idActivity, idVacant, email }) => ({
        url: `/stages/waiting-message-activity?idActivity=${idActivity}&idVacant=${idVacant}&email=${email}`,
      }),
    }),

    getParameter: builder.query<IParameterResponse, IParameterRequest>({
      query: ({ parameterName }) => ({
        url: `/stages/parameter/name?parameterName=${parameterName}`
      })
    }),
  }),
});

export const {
  useGetActivitiesByIdStageQuery,
  useGetActivityStatusQuery,
  useChangeStatusMutation,
  useCancelMeetingMutation,
  useReprogramMeetingQuery,
  useGetListCalendarQuery,
  useScheduleMeetingMutation,
  useConfirmScheduleMutation,
  useGetScheduleQuery,
  useGetEnterviewDataQuery,
  useGetNoCurrentActivityQuery,
  useGetWaitingMessageForActivityQuery,
  useGetParameterQuery,
} = stagesExtensionApi;
